import { render, staticRenderFns } from "./ReservationPoliciesForm.vue?vue&type=template&id=61c79c42&scoped=true&"
import script from "./ReservationPoliciesForm.vue?vue&type=script&lang=js&"
export * from "./ReservationPoliciesForm.vue?vue&type=script&lang=js&"
import style0 from "./ReservationPoliciesForm.vue?vue&type=style&index=0&id=61c79c42&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c79c42",
  null
  
)

export default component.exports